import { useMemo } from 'react';

import { SHOW_APPT_OPTIONS } from 'configs/siteAndTrustAttributes';
import { StaffSettingsTabsTree } from 'configs/RoutesConfig';
import { useSite } from 'context/SiteContext';
import { isGpSurgeryRequired } from 'utils/siteUtils';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { useSiteBooleanAttributes } from 'hooks/useAttribute';

export const useStaffListsTabs = () => {
  const { t } = useCommonTranslation();
  const { activeSite } = useSite();
  const [showApptOptions] = useSiteBooleanAttributes(SHOW_APPT_OPTIONS);
  const gpSurgeryRequired = isGpSurgeryRequired(activeSite);

  return useMemo(
    () => StaffSettingsTabsTree(t, { gpSurgeryRequired, showApptOptions }),
    [t, gpSurgeryRequired, showApptOptions],
  );
};
